import type { Wretch, WretchError } from 'wretch';

import { ApiErrorHandler, type ApiErrorHandlerOptions } from './ApiErrorHandler';

export const configureErrorCatchers = (
  wretchInstance: Wretch,
  options?: ApiErrorHandlerOptions | undefined,
): Wretch => {
  const errorHandler = new ApiErrorHandler(options);

  return wretchInstance
    .catcher(404, async (error: WretchError) => {
      await errorHandler.handleApiError(error.response, error.url);
      return null;
    })
    .catcher(400, async (error: WretchError) => {
      await errorHandler.handleApiError(error.response, error.url);
      return null;
    })
    .catcher(401, async (error: WretchError) => {
      await errorHandler.handleApiError(error.response, error.url);
      return null;
    })
    .catcher(403, async (error: WretchError) => {
      await errorHandler.handleApiError(error.response, error.url);
      return null;
    })
    .catcherFallback(async (error: WretchError) => {
      if (error.status >= 400 && error.status < 500) {
        await errorHandler.handleApiError(error.response, error.url);
        return null;
      }
      throw error;
    });
};
